<app-pageheader class="pageheader" [pageTitle]="'Instances'" [instanceTools]="false"
    [breadCrumbs]="this.breadCrumbItems">
</app-pageheader>
<div class="idn-acc-wrapper">
    <div class="details">        
        <div class="instance-details">
            <span>Instance Details :-</span>
            <div class="instance-data">Customer Name : {{this.ViewData.customerName}}</div>
            <div class="instance-data">Instance Name : {{this.ViewData.cname}}</div>
            <div class="instance-data">Instance Type : {{this.ViewData.instanceType}}</div>
            <div class="instance-data last-data">Version : {{this.ViewData.iciVersion}}</div>
        </div>
    </div>
</div>
<div class="page-container">
    <div class="table-header"><span>Application Logs</span></div>
    <div class="idn-filter">
        <form class="idn-grid-filter">
            <!-- <mat-form-field class="search-input">
                <mat-label>Search</mat-label>
                <input type="text" (keydown.enter)="filterData()" #search_input matInput [(ngModel)]="searchTerm" name="search">
                <span class="idn-custom-search" matSuffix>
                    <mat-icon (click)="filterData()">search</mat-icon>
                    <button type="button" mat-icon-button aria-label="Clear" (click)="ClearInput()">
                        <mat-icon>close</mat-icon>
                    </button>
                </span>
            </mat-form-field> -->
            <mat-form-field class="search-input">
              <mat-label>Level</mat-label>
              <mat-select (selectionChange)="filterData()" #levelData>
                <mat-option *ngFor="let stat of levelList" [value]="stat">
                  {{stat}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="displayedColumnsNewApplicationLogs.includes('ActivitySourceName')">
              <mat-label>Source</mat-label>
              <mat-select (selectionChange)="filterData()" #sourceData>
                <mat-option *ngFor="let item of sourceList" [value]="item">
                  {{item}}
                </mat-option>
              </mat-select>
            </mat-form-field>
        </form>
        <div class="filter-btns">
            <button class="clear-filter-btn" mat-stroked-button  (click)="clearFilter()"  matTooltip="Clear Filter"
            matTooltipClass="my-tooltip" matTooltipPosition="above" aria-label="clear Filter Button">
              <mat-icon class="icon-btn-spacer">filter_list_off</mat-icon>
            </button>
            <button class="adv-filter-btn" mat-stroked-button color="primary" (click)="enableAdvanceFilter()" #filterDiv  matTooltip="{{ !showIcon ? 'Apply Advance Filter' : null}}"
            matTooltipClass="my-tooltip" matTooltipPosition="above" aria-label="Advance Filter Button">
              <mat-icon class="icon-btn-spacer" >filter_alt</mat-icon>
              <mat-icon *ngIf="showIcon" class="adv-filter-icon" matTooltip="Filters Applied"
              matTooltipClass="my-tooltip" matTooltipPosition="below">circle</mat-icon>
            </button>
          </div>
    </div>
    <app-idn-table class="db-table" [data]="tableNewApplicationLogs" (onPageChanged)="pageChanged($event)" (onSort)="announceSortChange($event)"></app-idn-table>
</div>
<div class="pss-form-button-wrapper">
    <button mat-stroked-button (click)="onCancel()">Cancel</button>
</div>

<div class="filter-idn" #filterDiv *ngIf="advanceFilter">
    <div class="heading">
        <div class="label"><mat-icon>filter_alt</mat-icon><span>Applied Filters</span></div>
        <button id="closeButton" mat-icon-button (click)="closeFilter()" aria-label="Close Button">
            <mat-icon aria-label="close Button">close</mat-icon>
        </button>
    </div>
    <div class="ici-panel">
        <div class="ici-left-panel" *ngIf="!enableOldAppLogs">
            <!-- <mat-form-field class="pss-block-form">
                <mat-label>Select Type</mat-label>
                <mat-select matNativeControl [disabled]="true" [(ngModel)]="selectedLogType" required>
                    <mat-option value="0"> logs </mat-option>
                    <mat-option value="1"> Traces </mat-option>
                </mat-select>
            </mat-form-field>         -->
            <mat-form-field class="pss-block-form">
                <mat-label>{{instanceEnum.instance_view_application_log_start_datetime}}</mat-label>
                <input id="appStartDate" [(ngModel)]="getStartValueappLog" [min]="minAppStartDate"
                    [max]="maxAppStartDate" matInput type="datetime-local"
                    (ngModelChange)="applicationStartDateValueChange($event)" required
                    (change)="validateApplicationLogDates($event.target)">
            </mat-form-field>
            <mat-error *ngIf="startDateError">{{startDateErrorMsg}}</mat-error>

            <mat-form-field class="pss-block-form">
                <mat-label>{{instanceEnum.instance_view_application_log_end_datetime}}</mat-label>
                <input id="appEndDate" [(ngModel)]="getEndValueappLog" matInput type="datetime-local"
                    [min]="setApplicationMinEndDate" [max]="maxAppEndDate"
                    required
                    (change)="validateApplicationLogDates($event.target)" [disabled]="startDateError">
            </mat-form-field>
            <mat-error *ngIf="endDateError">{{endDateErrorMsg}}</mat-error>

            <!-- <mat-form-field class="pss-block-form">
                <mat-label>{{instanceEnum.instance_view_application_log_search_string}}</mat-label>
                <input matInput [(ngModel)]="getSearchValueappLog">
            </mat-form-field> -->

            <mat-form-field class="pss-block-form">
                <mat-label>Trace Id</mat-label>
                <input matInput [(ngModel)]="getTraceId">
            </mat-form-field>
            <mat-form-field  class="pss-block-form" >
                <mat-label>Level</mat-label>
                <mat-select matNativeControl #levelData [(ngModel)]="selectedLevel" (selectionChange)="levelChange($event)">               
                  <mat-option *ngFor="let level of levelList" [value]="level">
                    {{level}}
                  </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="ici-right-panel" *ngIf="!enableOldAppLogs" >
            <mat-form-field class="pss-block-form">
                <mat-label>Search</mat-label>
                <input matInput [(ngModel)]="getSearchValueappLog">
            </mat-form-field>
                
            <mat-form-field class="pss-block-form">
                <mat-label>Context User Id</mat-label>
                <input matInput [(ngModel)]="getContextUserId">
            </mat-form-field>

            <mat-form-field class="pss-block-form">
                <mat-label>Context Instance Entity Name</mat-label>
                <input matInput [(ngModel)]="getContextInstanceEntityName">
            </mat-form-field>

            <mat-form-field class="pss-block-form">
                <mat-label>Context Instance Id</mat-label>
                <input matInput [(ngModel)]="getContextInstanceId">
            </mat-form-field>
        </div>

        <div class="ici-left-panel" *ngIf="enableOldAppLogs">
            <mat-form-field class="pss-block-form">
                <mat-label>{{instanceEnum.instance_view_application_log_start_datetime}}</mat-label>
                <input id="appStartDate" [(ngModel)]="getStartValueappLog" [min]="minAppStartDate"
                    [max]="maxAppStartDate" matInput type="datetime-local"
                    (ngModelChange)="applicationStartDateValueChange($event)" required
                    (change)="validateApplicationLogDates($event.target)">
            </mat-form-field>
            <mat-error *ngIf="startDateError">{{startDateErrorMsg}}</mat-error>

            <mat-form-field class="pss-block-form">
                <mat-label>{{instanceEnum.instance_view_application_log_end_datetime}}</mat-label>
                <input id="appEndDate" [(ngModel)]="getEndValueappLog" matInput type="datetime-local"
                    [min]="setApplicationMinEndDate" [max]="maxAppEndDate"
                     required
                    (change)="validateApplicationLogDates($event.target)" [disabled]="startDateError">
            </mat-form-field>
            <mat-error *ngIf="endDateError">{{endDateErrorMsg}}</mat-error>

            <mat-form-field class="pss-block-form">
                <mat-label>{{instanceEnum.instance_view_application_log_search_string}}</mat-label>
                <input matInput [(ngModel)]="getSearchValueappLog">
            </mat-form-field>
        </div>
    </div>
    <div class="pss-drawer-button-wrapper btn-panel">
        <button class="mr-1" mat-flat-button mat-button color="primary" [disabled]="validateConfirmAction"  (click)="requestApplicationLog()">Request</button>
        <button class="mr-1" mat-stroked-button (click)="closeFilter()">Close</button>
    </div>
</div>